{
  "index.description": "Open the game on your phone or projector on the same Wi‑Fi network as the TV and use it as a controller.",
  "index.go_to_tv": "Go to TV",

  "tv.players": "Players",
  "tv.waiting": "Waiting…",
  "tv.scan_qr": "Scan QR code",
  "tv.point_camera": "Point your phone camera at this QR",
  "tv.enter_code": "Or enter the code below manually in the app:",
  "tv.same_wifi": "If the connection is weak, make sure your phone and TV are on the same Wi-Fi network",
  "tv.need_help": "I need help",
  "tv.post_qr_hint": "If the game takes a long time to start on your mobile device, tap \"Disconnect\" or refresh the page, then reconnect.\n\nFor best results, use the same Wi-Fi network on both the TV and your phone.",
  "tv.refresh_page": "Refresh page",
  "tv.choose_game": "Choose a game on your phone",
  "tv.refresh_qr": "Refresh",
  "tv.connecting": "Connecting…",
  "tv.available_games": "Available browser games:",
  "tv.establishing": "Establishing connection\nwith your phone",
  "tv.send_logs": "Send log",
  "tv.sending_logs": "Sending logs…",
  "tv.net.direct": "Great connection",
  "tv.net.different": "Your phone and TV seem to be on different networks. Connect them to the same Wi-Fi",
  "tv.net.internet": "Connected over the internet — some lag possible. Same Wi-Fi works best",
  "tv.net.relay": "Slow connection. Put your phone and TV on the same Wi-Fi",
  "tv.net.same_network_blocked": "You're on the same Wi-Fi, but a direct connection isn't available — some lag possible. Make sure your phone isn't on a guest network",
  "tv.net.different_lan": "Your phone and TV are connected to different routers — a direct connection isn't available, some lag possible. Connect them to the same Wi-Fi",
  "tv.net.failed": "Couldn't connect. Check both devices are on the same Wi-Fi and try again",
  "tv.net.unstable": "Unstable connection",
  "tv.net.got_it": "Got it",
  "tv.connection_lost": "Connection lost",
  "tv.connection_lost_sub": "Your phone lost connection with the TV.\nMake sure both devices are on the same Wi-Fi network",
  "tv.reconnect": "Reconnect",
  "tv.game_unavailable": "Game unavailable",
  "tv.game_unavailable_sub": "To play on TV, choose a game with this icon",
  "tv.p2p_rtt_title": "P2P: ICE latency (RTT) via WebRTC stats",
  "tv.webrtc_stats_title": "FPS (render), DataChannel msg/s (raw stream), ICE RTT (ms)",

  "game.game_over": "GAME OVER",
  "game.score": "Score:",
  "game.winner": "WINNER!",
  "game.tie": "TIE!",
  "game.pause": "PAUSED",
  "fruit.combo": "Combo x {n}",
  "fruit.score": "SCORE",
  "game.classic": "Classic",
  "game.arcade": "Arcade",
  "game.zen": "Zen",
  "game.level": "Level",
  "game.points": "Points",

  "calib.dark.title": "Too dark! We can't see you!",
  "calib.dark.sub": "Turn on the light or stand by a window",
  "calib.bright.title": "Too bright! We can't see you!",
  "calib.bright.sub": "Close the curtain or step away from the window",
  "calib.low_conf.title": "We can't make you out!",
  "calib.low_conf.sub": "Something may be blocking you, or you blend into the background",

  "tv.log_sent": "Log sent ({n} entries)",
  "tv.log_send_error": "Failed to send log",
  "tv.entered_code": "Entered code:",
  "tv.connected": "Connected!",
  "tv.choose_game_title": "Choose a game on your phone",
  "tv.choose_game_sub": "Open the app on your phone and choose the game you want to play",
  "tv.choose_mode_title": "Choose a game mode\nand number of players",
  "tv.choose_mode_sub": "Choose one of the available modes and the number of players",
  "tv.game": "Game",
  "tv.press_start": "Press START on your phone.",
  "tv.mode_summary": "Mode: {mode} · {players}.",
  "tv.players_one": "{n} player",
  "tv.players_many": "{n} players",
  "tv.pose_to_start": "Get into position — the game will start automatically.",
  "tv.p2p_connecting": "Connecting P2P…",
  "tv.p2p_connecting_sub": "Waiting for a direct channel with the phone (WebRTC DataChannel). On the same Wi‑Fi, STUN is usually enough; otherwise configure TURN.",
  "tv.p2p_failed": "P2P failed",
  "tv.p2p_failed_sub": "Check the network and the browser on the TV. Outside a local network TURN is often required — see docs/webrtc-native-connection.md",
  "tv.p2p_timeout": "P2P not established",
  "tv.p2p_timeout_sub": "Timed out. WebRTC and UDP are required; on some TVs/networks a connection is impossible without TURN.",
  "tv.p2p_reconnecting": "P2P: reconnecting…",
  "tv.p2p_no_link": "P2P: no connection",
  "tv.browser_outdated": "Your browser is outdated",
  "tv.browser_unsupported": "Unfortunately, the browser you are currently using\nis not supported.\nPlease use one of the supported browsers",

  "game.flight_over": "Flight over! ⭐ {stars}",
  "game.chef_time_up": "Time's up! Score: {score}",
  "game.chef_load_failed": "Failed to load the game",
  "game.sky_race_over": "Run over! ⭐ {stars} · {meters}",
  "game.iq_over": "Round over! Score: {score} · Correct: {correct} of {total}",
  "game.building_world": "{map} — building the world… {pct}%",
  "game.meters": "{n} m",
  "game.laser_dodge_warning": "Get out of the red zone!",
  "game.laser_dodge_round": "Round {n}",
  "game.laser_dodge_dodged": "Dodged! +{n}",
  "game.laser_dodge_hit": "Hit!",
  "game.laser_dodge_not_seen": "We can't see you",
  "game.laser_dodge_over": "Game over! Score {score} · Round {round}",
  "game.choose_track": "Choose a track",

  "map.ekibastuz": "Ekibastuz",
  "map.astana": "Astana",
  "map.paris": "Paris",
  "map.barcelona": "Barcelona",
  "map.almaty": "Almaty",

  "calib.hint.upper_body": "Stand inside the marked zone so that your shoulders and arms are visible",
  "calib.hint.waist_up": "Stand inside the zone so that your body is visible from the waist up",
  "calib.hint.full_body": "Stand inside the marked zone so that your whole body is visible",
  "calib.hint.slice_to_start": "Slice the fruit to start the game",
  "calib.hint.touch_yellow_zone": "Touch inside the yellow zone to start",
  "calib.hint.touch_zone": "Touch inside the zone to start",
  "calib.start": "Start",

  "headless.menu_title": "Choose a game",
  "headless.menu_sub": "Point your hand at a button and hold it there — or press OK on the remote",
  "headless.mode_title": "Mode",
  "headless.mode_timed": "Timed",
  "headless.mode_standard": "No timer",
  "headless.level_title": "Level",
  "headless.play_again": "Play again",
  "headless.to_menu": "Menu",
  "headless.result_title": "Run over!",
  "headless.result": "⭐ {stars} · {meters}",
  "headless.lost_body": "Step back into view to continue",
  "headless.level_default": "Valley"
}
